import type { SettingType } from '@/features/admin/settings/types'
import fetchClient from '@/lib/fetch'

export const settingsApi = {
  // Tous les settings plateforme (admin uniquement) ; l'écriture passe par PATCH /v1/data/settings
  // (features/admin/platform-setup/api).
  getAllSettings: async (): Promise<SettingType[]> => {
    return fetchClient('/v1/data/settings', {
      method: 'GET',
    })
  },
}
